import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
// Hooks
import useDialog from "hooks/useDialog";
// Async
import PropertyOwnershipsAsync from "store/propertyOwnerships/propertyOwnershipsAsync";
// Selectors
import { selectIsPropertyOwnershipsGroups } from "store/propertyOwnerships/propertyOwnershipsSelectors";
// Components
import TopProperties from "./TopProperties";
import DestinationTypes from "./DestinationTypes";
import AboutUs from "./AboutUs";
import SearchBanner from "components/SearchBanner";
import SetPasswordForm from "components/SetPassword.form";
import ContactUsPage from "./ContactUsPage";

const HomePage:React.FC = () => {
  const dispatch = useDispatch();
  const pathname = useLocation().pathname;
  const propertyOwnershipsGroups = useSelector(selectIsPropertyOwnershipsGroups);

  const { Dialog: SetPasswordDialog, openDialog:openSetPasswordDialog, closeDialog: closeSetPasswordDialog } = useDialog();
  
  useEffect(() => {
    dispatch(PropertyOwnershipsAsync.fetchPropertyOwnershipsGroups({groupSize: 4}));
    if (pathname.includes('register') || pathname.includes('recover-password')) openSetPasswordDialog();
    // eslint-disable-next-line
  }, []);

  return (
    <React.Fragment>
      <SetPasswordDialog maxWidth="sm">
        <SetPasswordForm onClose={closeSetPasswordDialog} />
      </SetPasswordDialog>

      <SearchBanner />
      <TopProperties topGroup={propertyOwnershipsGroups?.topGroup} />
      <DestinationTypes destinationTypeGroups={propertyOwnershipsGroups?.destinationTypeGroups} />
      <ContactUsPage />
      <AboutUs />
    </React.Fragment>
  );
}

export default HomePage;
